// 캘린더 그리드 헬퍼. 외부 라이브러리 없이 월 단위 6주 (42 cell) 그리드를 만든다.

export interface DayCell {
  date: Date;       // 자정 기준
  isCurrentMonth: boolean;
  isToday: boolean;
  iso: string;      // YYYY-MM-DD (key 용)
}

const startOfDay = (d: Date): Date => {
  const c = new Date(d);
  c.setHours(0, 0, 0, 0);
  return c;
};

const formatIso = (d: Date): string => {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

/**
 * 월(0-indexed)에 대해 6주 × 7일 = 42개 셀을 반환한다.
 * 첫 셀은 해당 월 1일이 속한 주의 일요일.
 */
export function buildMonthGrid(year: number, month: number): DayCell[] {
  const firstOfMonth = new Date(year, month, 1);
  const startWeekday = firstOfMonth.getDay(); // 0(Sun)–6(Sat)
  const gridStart = new Date(year, month, 1 - startWeekday);
  const today = startOfDay(new Date());

  const cells: DayCell[] = [];
  for (let i = 0; i < 42; i += 1) {
    const d = new Date(gridStart);
    d.setDate(gridStart.getDate() + i);
    cells.push({
      date: d,
      isCurrentMonth: d.getMonth() === month,
      isToday: d.getTime() === today.getTime(),
      iso: formatIso(d),
    });
  }
  return cells;
}

/** 월의 시작/끝 시각 (UTC ISO) — backend 의 from/to 쿼리에 사용 */
export function monthRangeIso(year: number, month: number): { from: string; to: string } {
  const from = new Date(year, month, 1);
  const to = new Date(year, month + 1, 1);
  return { from: from.toISOString(), to: to.toISOString() };
}

/** 해당 셀이 포함하는 날짜의 ISO(YYYY-MM-DD)와 비교용 */
export function isoOf(d: Date | string): string {
  if (typeof d === 'string') {
    return d.substring(0, 10);
  }
  return formatIso(startOfDay(d));
}

export const WEEKDAY_LABELS = ['일', '월', '화', '수', '목', '금', '토'];
